
import { defineComponent, PropType, ref, watch } from 'vue'
import EditableBlock from '@/components/EditableBlock.vue'
import ImageDisplay from '@/components/ImageDisplay.vue'
import EditableBlockInput from '@/components/EditableBlockInput.vue'
import { Tenant } from '@/pages/Settings/components/editors/TenantConfigEditor.vue'
import Tooltip from '@/components/Tooltip.vue'
import LogoDrop from '@/pages/NewSettings/components/CompanySettings/LogoDrop.vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'CompanyInformation',
  components: { LogoDrop, Tooltip, EditableBlockInput, ImageDisplay, EditableBlock },
  emits: ['update:company-information'],
  props: {
    tenant: {
      type: Object as PropType<Tenant>,
    }
  },

  setup (props) {
    const $store = useStore()
    const $sys = $store.getters['Services/Sys']
    const companyInformation = ref(props.tenant?.settings?.company ?? {})

    const fileHandler = (data, editState) => {
      editState.logo_uri = data.file
    }

    watch(() => props.tenant, () => {
      companyInformation.value = props.tenant?.settings?.company ?? {}
    })

    return {
      companyInformation,
      fileHandler
    }
  }
})
